<template>
  <div id="app" style="margin-top: 0px;">

    <!-- 这里是为了固定 -->
    <div style="width: 100%;height: 80px;">
      <el-row style="position: fixed; top: 0px;left: 8px;right: 8px;z-index: 999;">
        <Header></Header>
      </el-row>

      <TopMenu style="position: fixed; top: 30px;left: 8px;right: 8px;z-index: 999;"></TopMenu>
    </div>

    <router-view/>

    <!-- <el-row style="height: 50px;"></el-row> -->

    <el-row>
      <Footer></Footer>
    </el-row>

  </div>
</template>

<script src="https://ngdc.cncb.ac.cn/cdn/js/headerfooter-full.js"></script>
<script>
import Header from './components/general/Header'
import TopMenu from './components/general/TopMenu'
import Footer from './components/general/Footer'

export default {
  name: 'App',
  components:{Header,Footer,TopMenu}
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue